<template>
   <v-container v-use-case="'FindProbeCalibration'">
       <v-breadcrumbs :items="itemsForNavigation" style="padding: 5px 0px;"></v-breadcrumbs>
  <v-row no-gutters> 
    <v-col md="4" offset-md="4">
      <v-sheet>
        <v-autocomplete outlined dense item-text="registrationMark" @change="selectVehicle" :return-object="true" :items="vehicles" v-model="choosenVehicle"/>
        <span v-if="this.choosenVehicle.id != null">{{ $t("calibration.algorithmUsed")}}: {{ allProbeAlgorithms[probeAlgorithmId - 1] }}</span>
        <v-file-input :disabled="!choosenVehicle.id" @change="change"></v-file-input>
     <v-col cols="12"> <v-btn small v-use-case="'AddProbeCalibration'" class="float-right" @click="submit" color="primary">{{ $t("submit") }}</v-btn> </v-col><br>
        <v-simple-table dense v-if="calibrationItems && calibrationItems.length">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="color:white">
                  {{ $t("calibration.filled")}}
                </th>
                <th class="text-left" style="color:white">
                    {{ $t("calibration.probeValue")}}
                </th>
                 <th class="text-left" style="color:white">
                    {{ $t("calibration.fuelLevel")}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in calibrationItems"
                :key="item.name"
              >
                <td>{{ item.filledLiters }}</td>
                <td>{{ item.calibrationValue }}</td>
                <td>{{ item.fuelLevel }}</td>
              </tr>
            </tbody>
          </template>
    </v-simple-table>
    </v-sheet>
    <v-snackbar
      color="primary"
      top
      right
      elevation="2"
      v-model="displaySnackbar"
      :timeout="2000"
    >
      {{ $t("successfullEntry") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <br>
    <br>
    <v-alert
      v-if="errors.length"
      v-for="(error, index) of errors"
      :key="index"
      dense
      outlined
      type="error"
    >
      {{ error }}
    </v-alert>
    </v-col>
  </v-row>
   </v-container>
  

</template>

<script>
import ProbeCalibrationValuesInput from '@/components/v2/customInputs/ProbeCalibrationValuesInput'
import httpClient from '@/api/httpClient'
import translate from '@/utils/genTable/multilanguageHelper.js'
import read from 'read-excel-file'
export default {
  components: {
    ProbeCalibrationValuesInput
  },
  data() {
    return {
      errors: [],
      displaySnackbar: false,
      ids: [],
      vehicles: [],
      choosenVehicle: {},
      calibrationItems: [],
      itemsForNavigation: [
        {
          text: translate('Settings', 'navigation.settings'),
          disabled: true
        },
        {
          text: translate('Probe Calibration', 'navigation'),
          disabled: true
        }
      ],
      probeAlgorithmId: 0,
      allProbeAlgorithms: [
        this.$t('calibration.oldAlgorithm'),
        this.$t('calibration.point20Algorithm')
      ]
    }
  },
  async mounted() {
    this.choosenVehicle = {
      registrationMark: this.$t('choose'),
      id: null
    }
    httpClient
      .get('/vehicles?withFuelTankVolume=true&useProbe=true')
      .then(result => {
        this.vehicles = result.data
        this.vehicles.unshift({
          id: null,
          registrationMark: this.$t('choose')
        })
      })
  },
  methods: {
    change(event) {
      read(event).then(rows => {
        if (this.probeAlgorithmId != 1) {
          this.calibrationItems = rows.map(x => {
            return {
              filledLiters: x[0],
              calibrationValue: x[1],
              fuelLevel: 0
            }
          })

          let tankVolumeLeft = this.choosenVehicle.fuelTankVolume

          for (let i = this.calibrationItems.length - 1; i >= 0; i--) {
            let subtractValue = this.calibrationItems[i + 1]
              ? this.calibrationItems[i + 1].filledLiters
              : 0

            tankVolumeLeft -= subtractValue
            this.$set(this.calibrationItems[i], 'fuelLevel', tankVolumeLeft)
          }
        } else {
          this.calibrationItems = rows.map(x => {
            return {
              filledLiters: '/',
              calibrationValue: x[1],
              fuelLevel: x[0]
            }
          })
        }
      })
    },
    selectVehicle() {
      this.errors = []
      if (this.choosenVehicle.probeAlgorithm) {
        this.probeAlgorithmId = this.choosenVehicle.probeAlgorithm
      } else {
        this.probeAlgorithmId = 2
      }

      if (this.choosenVehicle.id) {
        httpClient
          .get('/probecalibrations/' + this.choosenVehicle.id)
          .then(response => {
            this.calibrationItems = response.data.probeCalibrationMeasures.map(
              x => {
                return {
                  calibrationValue: x.probeMeasuredValue,
                  fuelLevel: x.stepValue,
                  filledLiters: '/'
                }
              }
            )
          })
          .catch(() => {})
      }
    },
    submit() {
      this.errors = []
      var itemToSend = {
        vehicleId: this.choosenVehicle.id,
        probeCalibrationMeasures: this.calibrationItems.map(x => {
          return {
            stepValue: x.fuelLevel,
            probeMeasuredValue: x.calibrationValue
          }
        })
      }

      httpClient
        .post('/probeCalibrations', itemToSend)
        .then(x => {
          this.displaySnackbar = true
        })
        .catch(error => {
          this.errors = error.response.data.errors.map(x => {
            return x.Error
          })
        })
    }
  },
  watch: {
    calibrationItems: {
      handler() {}
    }
  }
}
</script>
<style>
</style>
